import React from "react";

import { Text, Button } from "@chakra-ui/react";

import { checkPermission } from "helpers/checkPermissions";
import { useAppSelector } from "store/store";

interface BotonVolverAProgramadaProps {
	onOpenReprogramar: () => void;
}

export const BotonVolverAProgramada: React.FC<BotonVolverAProgramadaProps> = (props) => {
	const { onOpenReprogramar } = props;
	const permisosUsuario = useAppSelector((state) => state.usuario.permissions.data);
	const isAdministrador = checkPermission(permisosUsuario, "administrador");
	const isDisabled = !isAdministrador;
	return (
		<React.Fragment>
			<Button
				backgroundColor="gray.400"
				w="12rem"
				_hover={{ bg: "gray.500" }}
				loadingText="Enviando"
				_active={{ bg: "gray.400" }}
				onClick={onOpenReprogramar}
				mr="1rem"
				isDisabled={isDisabled}
				title={isDisabled ? "Si necesita cambiar el estado, contacte con un administrador" : undefined}
			>
				<Text textStyle="body3" color="white">
					Volver a Programada
				</Text>
			</Button>
		</React.Fragment>
	);
};
